export default __webpack_public_path__ + "static/media/IMG_0050_7_11zon.a134c225.jpg";